import { render, staticRenderFns } from "./InfluencerStatistic.vue?vue&type=template&id=0daea15e&scoped=true"
import script from "./InfluencerStatistic.vue?vue&type=script&lang=js"
export * from "./InfluencerStatistic.vue?vue&type=script&lang=js"
import style0 from "./InfluencerStatistic.vue?vue&type=style&index=0&id=0daea15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daea15e",
  null
  
)

export default component.exports